import React from 'react';
import PropTypes from 'prop-types';
import _sum from 'lodash/sum';

import { TableBody, TableCell, TableRow } from '../TableComponents';
import { Number } from '../../Base';
import { COLOR } from '../../Theme';

const StudentCountRow = ({ data, examTitle }) => (
  <TableRow cellBorder={true} height={'72px'}>
    <TableCell minWidth={'100px'} wrap={true} rowSpan={2}>
      {examTitle}
    </TableCell>
    <TableCell wrap={true}>จำนวนคน</TableCell>
    {data.map((d, index) => (
      <TableCell key={index}>
        <Number value={d} textAlign={'center'} />
      </TableCell>
    ))}

    <TableCell>
      <Number value={_sum(data)} textAlign={'center'} />
    </TableCell>
  </TableRow>
);

const PercentageRow = ({ data }) => (
  <TableRow cellBorder={true} bgColor={COLOR.gridGrey}>
    <TableCell>คิดเป็นร้อยละ</TableCell>
    {data.map((item, index) => (
      <TableCell key={index}>
        <Number value={item} variant={'twoDecimals'} textAlign={'center'} />
      </TableCell>
    ))}
    <TableCell>
      <Number value={100} textAlign={'center'} />
    </TableCell>
  </TableRow>
);

const TableBodySection = ({ row, examTitle, percentageRow }) => (
  <TableBody>
    <StudentCountRow data={row} examTitle={examTitle} />
    <PercentageRow data={percentageRow} />
  </TableBody>
);

export default TableBodySection;
